import Login from '../views/Sessions/Login/Index.vue'

const Error404 = resolve => {
    require.ensure(['../views/Sessions/Error404/Index.vue'], () => {
        resolve(require('../views/Sessions/Error404/Index.vue'))
    })
}

const ChangePassword = resolve => {
    require.ensure(['../views/Sessions/ChangePassword/Index.vue'], () => {
        resolve(require('../views/Sessions/ChangePassword/Index.vue'))
    })
}

// new view path
const Dashboard = resolve => {
    require.ensure(['../views/Dashboard/Index.vue'], () => {
        resolve(require('../views/Dashboard/Index.vue'))
    })
}


/// compilation of all routes into an variable
export default {
    children: [
        {
            path: '/login',
            component: Login,
            meta: {
                requiresAuth: false,
                title: 'message.login'
            }
        },
        {
            path: '/',
            component: Dashboard,
            meta: {
              requiresAuth: true,
              title: 'Home',
              breadcrumb: [
                {name: 'Home', link: '/', showLink: true},
              ]
            }
        },
        {
            path: '/dashboard',
            component: Dashboard,
            meta: {
              requiresAuth: true,
              title: 'Home',
              breadcrumb: [
                {name: 'Home', link: '/', showLink: true}
              ]
            }
        },       
        {
            path: '/*',
            component: Error404,
            meta: {
              requiresAuth: false,
              title: 'message.purchaseOrders',
              breadcrumb: []
            }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/routes.js